import isNewReduxUtil from 'modules/redux/utils/is-new'
import { validateModelUtil } from 'models/validators'
import REDUX_ACTION from 'modules/redux/constants/action'
import REDUX_OPTION from 'modules/redux/constants/option'
import openErrorBannerAction from 'modules/banner/actions/open-error'
import { getMergedDataReduxUtil } from 'modules/redux/utils/legacy/get-merged-data'
import { getUpdatedDataReduxUtil } from 'modules/redux/utils/legacy/get-updated-data'
import { getObjectUtil } from 'packages/src'

/**
 * Sets the instance's validation in a success state.
 * @param  {string} path
 * @returns {Function}
 */
function validationSuccess (path) {
  return {
    type: REDUX_ACTION.VALIDATION_SUCCESS,
    payload: {
      path
    }
  }
}

/**
 * Sets the mode's validation object in an error state.
 * @param  {string} path
 * @param  {Object} validation
 * @returns {Function}
 */
function validationErrorFn (path, validation) {
  return {
    type: REDUX_ACTION.VALIDATION_ERROR,
    payload: {
      path,
      validation
    }
  }
}

/**
 * Sets the validation error in the `state.error` and trigger it
 * in the instance's validation object.
 * @param  {string} path
 * @param  {Object} validation
 * @param  {Object} [options={}]
 * @returns {Function}
 */
function validationErrorLegacyReduxAction (path, validation, options = {}) {
  return dispatch => {
    if (!options[REDUX_OPTION.SHOULD_HIDE_BANNER]) {
      dispatch(
        openErrorBannerAction(validation.value)
      )
    }
    return dispatch(
      validationErrorFn(path, validation)
    )
  }
}

/**
 * Validates the instance at the given path.
 * @param  {string} path
 * @param  {Object} [options={}]
 * @returns {Function}
 */
function validateLegacyReduxAction (path, options = {}) {
  return (dispatch, getState) => {
    const instance = getObjectUtil(getState(), path)
    const data = getMergedDataReduxUtil(instance, instance.changed)
    let dataToValidate
    if (isNewReduxUtil(instance)) {
      dataToValidate = data
    } else {
      dataToValidate = getUpdatedDataReduxUtil(instance)
    }
    const className = (
      instance.className ||
      instance.data.className
    )
    const validation = validateModelUtil(
      dataToValidate,
      className,
      data
    )
    if (validation !== true) {
      return dispatch(
        validationErrorLegacyReduxAction(path, validation, options)
      )
    }
    return dispatch(
      validationSuccess(path)
    )
  }
}

export {
  validateLegacyReduxAction,
  validationErrorLegacyReduxAction
}
